import ImportFormPage from '@/modules/imports/pages/ImportFormPage'

export default [
  {
    name: 'ImportCreate',
    path: '/import/create',
    component: ImportFormPage,
    props: route => ({ type: route.params.type, readonly: false }),
    project: true,
    meta: {
      auth: ['createImport']
    }
  }
]



// WEBPACK FOOTER //
// ./src/modules/imports/router/index.js